import { createI18n } from 'vue-i18n'

import id from './id'
import en from './en'

const savedLanguage = localStorage.getItem('language')

const locale = ['id', 'en'].includes(savedLanguage)
  ? savedLanguage
  : 'id'

const i18n = createI18n({
  legacy: true,
  locale,
  fallbackLocale: 'en',

  messages: {
    id,
    en
  }
})
export default i18n